// Imports
// UI Imports
import { Checkbox, FormControlLabel } from '@material-ui/core'
import Grid from '@material-ui/core/Grid/Grid'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
// App Imports
import { nullToEmptyString } from '../../../setup/helpers'
import { messageShow } from '../../common/api/actions'
import BrandedLoading from '../../common/BrandedLoading'
import SectionPaper from '../../common/SectionPaper'
import { save } from '../api/actions/mutation'
import routes from '../api/routes'
import styles from './styles'

const CHECK_BOX = "checkbox";

// Component
class CreateOrUpdate extends Component {

  constructor(props) {
    super(props)

    this.feedbacks = {
      title: '',
      feedback: '',
      type: 'complaint',
      suggestionFlag: ''
    }

    this.state = {
      isLoading: false,
      isSubmitting: false,
      feedbacks: this.feedbacks
    }
  }

  componentDidMount() {
    this.refresh()
  }

  refresh = async () => {
    const { messageShow } = this.props

    this.isLoadingToggle(true)

    try {
      /* const { data } = await detail()

      if(data.success && data.data) {
        this.setState({
          feedbacks: data.data
        })
      } */
    } catch (error) {
      messageShow('Some error occurred. Please try again.')
    } finally {
      this.isLoadingToggle(false)
    }
  }

  onSave = async event => {
    event.preventDefault()

    const { save, messageShow, history } = this.props

    const { feedbacks } = this.state

    this.isSubmittingToggle(true)

    try {
      const { data } = await save(feedbacks)

      this.isSubmittingToggle(false)
      history.push(routes.feedbackList.path)
      messageShow(data.message)
    } catch (error) {
      this.isSubmittingToggle(false)

      messageShow('Some error occurred. Please try again.')
    }
  }

  isLoadingToggle = isLoading => {
    this.setState({
      isLoading
    })
  }

  isSubmittingToggle = isSubmitting => {
    this.setState({
      isSubmitting
    })
  }

  onChange = (e) => {
    let { name, value, type, checked } = e.target;
    const { feedbacks } = this.state

    feedbacks[name] = type === CHECK_BOX ? !!checked : value

    this.setState({
      feedbacks
    })
  }

  render() {
    const { classes } = this.props
    const { isLoading, isSubmitting, feedbacks } = this.state
    let { type, suggestionFlag, title, feedback } = feedbacks;

    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Feedback Message
          </Typography>
        </Toolbar>

        <Grid item xs={12} lg={6}>
          <SectionPaper padding>
            {
              isLoading
                ? <BrandedLoading />
                : <form onSubmit={this.onSave}>
                  {/* Input - Message Title */}
                  <Grid item xs={12}>
                    <TextField
                      name={'title'}
                      value={nullToEmptyString(title)}
                      onChange={this.onChange}
                      label={'Title'}
                      placeholder={'Enter Title'}
                      required={true}
                      margin={'dense'}
                      autoComplete={'off'}
                      fullWidth
                      autoFocus
                    />
                  </Grid>

                  {/* Input - Message feedback */}
                  <Grid item xs={12}>
                    <TextField
                      name={'feedback'}
                      value={nullToEmptyString(feedback)}
                      onChange={this.onChange}
                      label={'feedback'}
                      placeholder={'Enter feedback'}
                      required={true}
                      margin={'dense'}
                      autoComplete={'off'}
                      multiline
                      rowsMax={3}
                      rows={3}
                      fullWidth
                    />
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!nullToEmptyString(type)}
                            onChange={this.onChange}
                            color='primary'
                            name={"type"}
                            required={!(type || suggestionFlag)}
                          />
                        }
                        label='Complaint'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!nullToEmptyString(suggestionFlag)}
                            onChange={this.onChange}
                            color='primary'
                            name={"suggestionFlag"}
                            required={!(type || suggestionFlag)}
                          />
                        }
                        label='Suggestion'
                      />
                    </Grid>
                  </Grid>

                  {/* Button - Save */}
                  <Grid item xs={12} className={classes.buttonsContainer}>
                    <IconButton
                      type={'submit'}
                      aria-label={'Save'}
                      color={'primary'}
                      disabled={isSubmitting}
                    >
                      <CheckIcon/>
                    </IconButton>
                  </Grid>
                </form>
            }
          </SectionPaper>
        </Grid>
      </div>
    )
  }
}

// Component Properties
CreateOrUpdate.propTypes = {
  feedbacks: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

// Component State
function createOrEditState(state) {
  return {
    feedbacks: state.feedbacks
  }
}

export default connect(createOrEditState, { save, messageShow })(withStyles(styles)(CreateOrUpdate))
